import React from "react"
import { Header, Rate, RateProps } from "./components"
import { Collapse } from "@walmart-web/livingdesign-components"
import "./index.scss"

interface SummaryCardProps {
	title: string
	color: string
	icon: React.ReactChild
	isOpen?: boolean
	rates: Array<RateProps>
}

const SummaryCard: React.FC<SummaryCardProps> = ({
	title,
	color,
	icon,
	isOpen,
	rates,
	children,
}) => (
	<div className="summary-card">
		<Header title={title} color={color} icon={icon} />
		<div className="summary-rates">
			{rates.map((rate) => (
				<Rate key={`summary-card-${rate.title}`} {...rate} />
			))}
		</div>
		<Collapse UNSAFE_className="summary-collapse" isOpen={isOpen}>
			{children}
		</Collapse>
	</div>
)

export default SummaryCard
